<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :allow-edit="false"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      syncValueChange
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author Liang Gangqiang
// Date 2022-05-10 16:24:15

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

let ENTITY_NAME = {
    1: 'emArchBasicData',
    2: 'sithMesPrdToolsInfo',
    3: 'emArchTool',
}

let CUSTOM_VUEX_NAME = {
    2: 'scrap',
}

export default {
    name: "emArchScrapProcessAspWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins, emCommonUtilMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return process.env.VUE_APP_EM_ARCHIVE_URL + "/emArchScrapProcessAsp/complete-feedback";
        },
        scrapType() {
            return this.$_emWorkflowTaskMixin_businessData.scrapType;
        },
        scrapEntityName() {
            return ENTITY_NAME[this.scrapType];
        },
        scrapItemInputs() {
            let tempList = [];
            if (this.scrapType === 2 || this.scrapType === 3) {
                tempList.push({key: 'number', label: '报废数量', isInput: true});
            }
            return tempList;
        },
        scrapItemIdList() {
            let scrapItems = this.$_emWorkflowTaskMixin_businessData.scrapItems;
            if (this.hasCode(scrapItems)) {
                try {
                    let itemList = JSON.parse(scrapItems);
                    let tempList = [];
                    for (let item of itemList) {
                        tempList.push(item.id);
                    }
                    return tempList;
                } catch (e) {
                    console.log(e);
                }
            }
            return [];
        },
        scrapCustomVuexName() {
            return CUSTOM_VUEX_NAME[this.scrapType]
        },
        config() {
            return {
                'task_init_scrap': {
                    name: '填写报废信息',
                    variables: [
                        {
                            label: '操作选择',
                            name: 'createTo',
                            saveTo: this.SAVE_TO.APPROVE,
                            type: this.VALUE_TYPE.SELECT,
                            options: [
                                {value: 1, text: '提交'},
                                {value: 2, text: '取消'},
                                {value: 3, text: '补充信息'},
                            ],
                        },
                        {
                            label: '报废详情',
                            name: 'scrapItems',
                            type: this.VALUE_TYPE.TABLE,
                            saveTo: this.SAVE_TO.DATABASE,
                            entityName: this.scrapEntityName,
                            customVuexName: this.scrapCustomVuexName,
                            filterHolder: {
                                idListFilter: this.scrapItemIdList
                            },
                            needModelFields: true,
                            disableAutoSave: true,
                            fields: this.scrapItemInputs,
                            initData: true
                        }
                    ],
                    addVariableByApprove: approve => {
                        let temp = {1: '报废', 2: '取消'};
                        if (approve === 1 || approve === 2) {
                            return {name: 'currentResult', value: temp[approve]}
                        }
                    },
                    withComment: true,
                    withAttachment: true,
                    postByApprove: (approve, postData) => {
                        if (approve === 1) {
                            let scrapItems = JSON.parse(postData.scrapItems);
                            let tempList = [];
                            switch (this.scrapType) {
                                case 1:
                                    for (let item of scrapItems) {
                                        tempList.push(item.id)
                                    }
                                    return {
                                        url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emArchBasicData/scrap",
                                        data: {
                                            idList: tempList
                                        }
                                    }
                                case 2:
                                    for (let item of scrapItems) {
                                        tempList.push({
                                            key: item.id,
                                            value: item.number
                                        })
                                    }
                                    if (tempList.length > 0) {
                                        return {
                                            url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdToolsInfo/scrap",
                                            data: {
                                                items: tempList
                                            }
                                        };
                                    }
                                    break;
                                case 3:
                                    for (let item of scrapItems) {
                                        tempList.push({
                                            key: item.id,
                                            value: item.number
                                        })
                                    }
                                    return {
                                        url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emArchTool/scrap",
                                        data: {
                                            items: tempList
                                        }
                                    };
                            }
                        }
                    },
                    userSelectMap: {
                        1: [{
                            name: 'task_scrap_confirm_assignee',
                            saveName: 'currentAssignee',
                            saveToDatabase: true,
                            require: true
                        }],
                        3: [{
                            name: 'task_init_scrap_assignee',
                            saveName: 'currentAssignee',
                            saveToDatabase: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_scrap_confirm',
                        2: 'EndEvent',
                        3: 'task_init_scrap'
                    }
                },
                'task_scrap_confirm': {
                    name: '信息审核',
                    variables: [
                        {
                            label: '审核结果',
                            name: 'confirmResult',
                            saveTo: this.SAVE_TO.APPROVE,
                            type: this.VALUE_TYPE.SELECT,
                            options: [
                                {value: 1, text: '通过'},
                                // {value: 2, text: '不通过'},
                                {value: 3, text: '继续审核'},
                            ],
                        }
                    ],
                    withComment: true,
                    userSelectMap: {
                        3: [{
                            name: 'task_scrap_confirm_assignee',
                            saveName: 'currentAssignee',
                            saveToDatabase: true,
                            require: true
                        }],
                    },
                    approveToNextTask: {
                        1: 'EndEvent',
                        2: 'task_init_scrap',
                        3: 'task_scrap_confirm'
                    }
                },
                'task_do_scrap': {
                    name: '报废',
                    approveToNextTask: 'EndEvent'
                },
                'EndEvent': {
                    name: '结束'
                }
            };
        }
    }
};
</script>